import { EMPTY_SELECT_OPTION } from 'Constants/form'

import { ShippingAddressTypeEnum } from 'Types/address/address.types'

import { ShippingAddressFormSchema } from './ShippingAddressForm.types'

export const shippingFormDefaultValues: ShippingAddressFormSchema = {
  _label: '',
  address: '',
  addressType: ShippingAddressTypeEnum.HOME_ADDRESS,
  city: '',
  country: EMPTY_SELECT_OPTION,
  name: '',
  nameAddition: '',
  street: '',
  streetNumber: '',
  zipcode: '',
}
